export default "__VITE_ASSET__lg8Qm0_K__"